/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

module.exports = require("regenerator-runtime");




//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/regenerator/index.js
// module id = 77
// module chunks = 76